/**
 * Karr Health's own address (hf-6, docs/KARR_HOSPITAL_FACE_SPEC.md 4.1).
 *
 * health.karr.pro serves the same bundle as karr.pro. On a `health.` host the
 * root is the hospital's front door and sign-in is /health/signin, so a nurse
 * never meets the accounting site. On karr.pro, /health/* works the same way,
 * so links, QR codes and the demo work before the DNS is done.
 *
 * Tiny on purpose: the router and the landing read it on the first paint.
 */

/** Is this page served from a hospital address (health.karr.pro, health.localhost)? */
export function isHealthHost(hostname: string = typeof window !== 'undefined' ? window.location.hostname : ''): boolean {
    return /^health\./i.test(hostname);
}

/** Where a signed-out person goes to sign in, on this host. */
export function signInPath(hostname?: string): '/health/signin' | '/auth/signin' {
    return isHealthHost(hostname) ? '/health/signin' : '/auth/signin';
}

/** Is this sign-in a hospital login (a badge number and a PIN, made by hms-staff-auth)? */
export function isHospitalLogin(user: { app_metadata?: Record<string, unknown> } | null | undefined): boolean {
    const hms = user?.app_metadata?.hms as { org_id?: string } | undefined;
    return !!hms?.org_id;
}
